/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
const { selectDesktop } = Slices.appSlice;
import css from './index.module.scss';
import noImg from '../../assets/no-itm.png';

export default function ProductTileImage({ imageSrc, productName, handleCart }) {
  const isDesktop = useSelector(selectDesktop);
  return (
    <div className={css.thumbnail}>
      <img
        src={imageSrc}
        alt={productName}
        width="80"
        className={css.image}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImg;
        }}
        onClick={!isDesktop && handleCart}
      />
    </div>
  );
}
